import {
	autoinject,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';
import {
	AcurityTable,
	TableColumnDefinition,
} from '~/components/acurity-table/acurity-table';

@autoinject
@customElement('a-data-compare-table')
@useView(PLATFORM.moduleName('components/acurity-table/acurity-table.html'))
export class DataCompareTable extends AcurityTable {
	// Override
	protected renderColumnClassName(
		columnInfo: TableColumnDefinition,
		sortable: boolean,
	): string {
		let className: string = 'text-left';
		if (columnInfo.dataType && columnInfo.dataType.name === 'Boolean') {
			className += ' select-checkbox';
		}

		return className;
	}

	/**
	 * @override
	 */
	protected setRowListenerAndDescription($tableRows: JQuery) {
		$tableRows.each((_, el) => {
			const checkboxElement: Element = el
				.getElementsByClassName('select-checkbox')
				.item(0);
			if (checkboxElement) {
				if (checkboxElement.textContent === 'false') {
					checkboxElement.classList.add('disabled');
				}
				checkboxElement.textContent = '';
			}
		});
	}

	// Override
	protected setNormalTableOptions(options) {
		super.setNormalTableOptions(options);
		options.select = {
			style: 'multi',
			selector: 'td.select-checkbox:not(.disabled)',
		};
	}
}
